import { Close, SubdirectoryArrowRight } from "@mui/icons-material"
import { Box, ClickAwayListener, Grow, IconButton, List, ListItemButton, ListItemIcon, ListItemText, Paper, Popper, Typography } from "@mui/material"
import { NUDGE_PROMPTS } from "connected-components/ai-teammate/helpers/constants"
import type { NudgePrompt } from "./types"

interface NudgePopoverProps {
  open: boolean
  anchorEl: HTMLElement | null
  onClose: () => void
  onQuestionClick: (prompt: NudgePrompt) => void
}

// Discoverability nudge anchored to the Kelly AI nav item. Uses Popper (not Popover) so the
// rest of the app stays interactive and undimmed — this is a gentle nudge, not a modal.
// Clicking away or the "x" dismisses it.
export function NudgePopover({ open, anchorEl, onClose, onQuestionClick }: NudgePopoverProps) {
  return (
    <Popper
      open={open && !!anchorEl}
      anchorEl={anchorEl}
      placement="right-start"
      transition
      sx={{ zIndex: (theme) => theme.zIndex.modal }}
    >
      {({ TransitionProps }) => (
        <Grow {...TransitionProps} style={{ transformOrigin: "top left" }}>
          <Paper elevation={6} sx={{ ml: 1, maxWidth: 320 }}>
            <ClickAwayListener onClickAway={onClose}>
              <Box>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", pl: 2, pr: 1, pt: 1 }}>
                  <Typography variant="subtitle2" color="primary">Try your AI data teammate</Typography>
                  <IconButton size="small" aria-label="Dismiss" onClick={onClose}>
                    <Close fontSize="small" />
                  </IconButton>
                </Box>
                <List dense disablePadding sx={{ pb: 1 }}>
                  {NUDGE_PROMPTS.map((prompt) => (
                    <ListItemButton key={prompt.id} onClick={() => onQuestionClick(prompt)}>
                      <ListItemIcon sx={{ minWidth: 32 }}>
                        <SubdirectoryArrowRight fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary={prompt.text} />
                    </ListItemButton>
                  ))}
                </List>
              </Box>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  )
}
